export default "__VITE_ASSET__DDh7WkNQ__"